const ConfirmPopupActions = ({
  onCancel,
  onDontSend,
  onConfirm,
  cancelLabel,
  dontSendLabel,
  confirmLabel,
  okButtonRef,
}: {
  onCancel: () => void;
  onDontSend?: () => void;
  onConfirm: () => void;
  cancelLabel: string;
  dontSendLabel?: string;
  confirmLabel: string;
  okButtonRef: React.RefObject<HTMLElement>;
}) => {
  return (
    <div className="h-max p-2.5">
      <div className="flex w-full justify-end gap-2.5">
        <button
          onClick={onCancel}
          className="box-border flex h-9 w-[110px] items-center justify-center rounded-md bg-white/[0.04] px-8 py-2 text-sm font-normal leading-[1.5] text-[#abadad] outline-none hover:bg-white/[0.08] hover:text-white focus:bg-white/[0.08] focus:text-white focus:outline-none"
        >
          {cancelLabel}
        </button>
        {dontSendLabel && onDontSend && (
          <button
            onClick={onDontSend}
            className="box-border flex h-9 w-[110px] items-center justify-center rounded-md bg-white/[0.04] px-8 py-2 text-sm font-normal leading-[1.5] text-[#abadad] outline-none hover:bg-white/[0.08] hover:text-white focus:bg-white/[0.08] focus:text-white focus:outline-none"
          >
            {dontSendLabel}
          </button>
        )}
        <button
          onClick={onConfirm}
          className="box-border flex h-9 w-[110px] items-center justify-center rounded-[5px] bg-white/[0.16] px-8 py-2 text-sm font-normal leading-[1.5] text-white outline-none hover:bg-white/[0.24] focus:bg-white/[0.24] focus:outline-none"
          ref={okButtonRef as React.RefObject<HTMLButtonElement>}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  );
};

export default ConfirmPopupActions;
